module.exports = __webpack_public_path__ + "static/media/29ADMSPC27.392be1f6.jpg";